import API_MAPS from "../modules/API/api_maps";
/*

    Summary
        0 - Functions
        1 - Initial Config
        2 - Init Map


*/
//pegar lat e lng do usuário caso ele tenha permitido no browser

let userLat = 0;
let userLng = 0;

if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
        (position) => {
            userLat = position.coords.latitude;
            userLng = position.coords.longitude;
            // Você pode usar userLat e userLng conforme necessário
            // Por exemplo, salvar em variáveis globais ou enviar para o mapa
            window.userLocation = { lat: userLat, lng: userLng };
        },
        (error) => {
            console.warn('Geolocation permission denied or unavailable.', error);
        }
    );
} else {
    console.warn('Geolocation is not supported by this browser.');
}

/*---------------------- 0 - Functions -------------------*/
function getAddressesStores() {
    let addressesObj = $.ajax({
        type: "POST",
        url: $("#page-maps-stores").attr('adressesRoute'),
        data: "lat=" + userLat + "&lng=" + userLng,
        dataType: "json",
        headers: {
            'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        }
    }).done(() => {
        const allAddress = addressesObj.responseJSON;
        API_MAPS(allAddress);
    });
}

/*---------------------- 1 - Initial Config -------------------*/
//const socialIcons = document.getElementById('component--social-icons')
//socialIcons.style.display = 'none'

const header = document.querySelector('header')
header.classList.add("maps-page")

const footer = document.querySelector('footer')
footer.classList.add("maps-page")


document.documentElement.style.setProperty('--zoom', 1);



/*----------------------  2 - Init Map -------------------*/
window.onload = ()=>{
    getAddressesStores()
}
